import React from "react";
import styled from "styled-components";
import Icon from "../icons";

const footerItems = [
  {
    id: 1,
    text: "Terms of Service",
    redirectUrl: "/terms-service",
    textColor: "white",
  },
  {
    id: 2,
    text: "Privacy",
    redirectUrl: "https://www.mars.com/privacy",
    textColor: "white",
  },
  {
    id: 3,
    text: "Do Not Sell My Information",
    redirectUrl: "https://privacyportal-eu.onetrust.com/webform/5f2759ff-9efe-412c-a3be-f13092d2c945/98373dac-6247-48a6-a190-f0094af43ee8",
    textColor: "white",
  },
  {
    id: 4,
    text: "Cookies",
    redirectUrl: "#",
    textColor: "white",
    onClick: (e) => {
      window.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open");
      e.preventDefault();
    },
  },
];

const footerButtons = [
  {
    id: 1,
    iconName: "sn-instagram-20",
    redirectUrl: "https://instagram.com/goodfriend",
    ariaLabel: "Instagram",
  },
  {
    id: 2,
    iconName: "sn-facebook-20",
    redirectUrl: "https://www.facebook.com/goodfriendbykinship",
    ariaLabel: "Facebook",
  },
  // { id: 3, iconName: "sn-twitter-20", redirectUrl: "/twitter" },
];

const FooterButtons = styled.div`
  bottom: 115px;
  margin: 0;
  width: 100%;
  position: relative;

  ${({ theme }) => theme.mq.md`
    padding-right: 10px;
    position: static;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `};
`;

const Footer = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.colors.gray};
  grid-area: footer;
  grid-template-columns: 1fr;
  text-align: center;
  height: auto;
  padding-top: 1.5rem;

  ${({ theme }) => theme.mq.md`
    padding-top: 0rem;
    align-self: flex-end;
    background-color: ${theme.colors.white};
    grid-area: footer;
    display: grid;
    height: 70px;
    grid-template-columns: 1fr 185px;
    z-index: 1;
  `}
`;

const FooterItemWrapper = styled.div`
  display: block;
  margin: 0;
  a {
    color: ${({ theme }) => theme.themeColors.darkGreen4};
  }

  ${({ theme }) => theme.mq.md`
    margin: 0 0.7rem 0 0.7rem;

    a {
      color: ${theme.themeColors.darkGreen4};
      font-size: ${theme.fontSize(1)};

      :hover {
        text-decoration: underline;
      }

      transition: ${theme.opacityTransition};
    }
  `}
`;

const OuterFooterItemWrapper = styled.div`
  margin: 10px auto;

  ${({ theme }) => theme.mq.md`
    margin: auto 0;
  `}
`;

const OuterFooterCopyrightWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: auto 0;
`;

const FooterCopyrightWrapper = styled.p`
  margin: auto;
  margin: 100px auto 24px auto;
  opacity: 0.5;
  color: ${({ theme }) => theme.themeColors.darkGreen4};
  font-size: ${({ theme }) => theme.fontSize(1)};

  ${({ theme }) => theme.mq.md`
    margin: 0 20px;
    line-height: 1;
  `}
`;

const FooterButtonContainer = styled.button`
  cursor: pointer;
  margin: auto 10px;
  background-color: transparent;
  border: none;

  :hover {
    opacity: 0.5;
  }

  :focus {
    outline: 0;
  }

  :focus-visible {
    outline: 2px solid #0070f3;
  }

  transition: ${({ theme }) => theme.opacityTransition};
`;

const FooterTextItemsWrapper = styled.div`
  display: block;
  text-align: center;

  ${({ theme }) => theme.mq.md`
    display: flex;
    flex-wrap: wrap;
  `}
`;

const LogoAndTextItems = styled.div`
  display: grid;
  padding: 0;

  ${({ theme }) => theme.mq.md`
    margin-left: 10px;
    display: flex;
    flex-wrap: wrap;
  `}
`;

const GlobalFooter = React.forwardRef(() => {
  return (
    <Footer>
      <LogoAndTextItems>
        <FooterTextItemsWrapper>
          {footerItems.map((item) => {
            return (
              <OuterFooterItemWrapper key={item.id}>
                <FooterItemWrapper>
                  <a
                    href={item.redirectUrl}
                    target="_blank"
                    rel="noreferrer"
                    onClick={item.onClick}
                  >
                    {item.text}
                  </a>
                </FooterItemWrapper>
              </OuterFooterItemWrapper>
            );
          })}
        </FooterTextItemsWrapper>
        <OuterFooterCopyrightWrapper>
          <FooterCopyrightWrapper>
            &#169; {new Date().getFullYear()} Kinship Partners, Inc.
          </FooterCopyrightWrapper>
        </OuterFooterCopyrightWrapper>
      </LogoAndTextItems>
      <FooterButtons>
        {footerButtons.map((item) => {
          return (
            <a
              key={item.id}
              href={item.redirectUrl}
              rel="noreferrer"
              target="_blank"
            >
              <FooterButtonContainer aria-label={item.ariaLabel}>
                <Icon name={item.iconName} />
              </FooterButtonContainer>
            </a>
          );
        })}
      </FooterButtons>
    </Footer>
  );
});

GlobalFooter.propTypes = {};

GlobalFooter.defaultProps = {};

export default GlobalFooter;
